module.exports = __webpack_public_path__ + "img/support__img1.6c7fcfa0.png";